// extracted by mini-css-extract-plugin
export default {"component":"Footer_component__SKk1G","section1":"Footer_section1__BAaYn","section3":"Footer_section3__C3vEs","section2":"Footer_section2__PFXX+"};